export const PlusShieldIllustration = ({ className }: TProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="192"
    height="108"
    fill="none"
    className={className}
    viewBox="0 0 257 144"
  >
    <g filter="url(#a)">
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M130.344 27.624a5.11 5.11 0 0 0-4.025 0l-32.656 7.468a10.214 10.214 0 0 0-6.19 9.387v35.037a35.75 35.75 0 0 0 18.013 31.037c6.286 2.378 16.173 8.789 22.835 8.789 6.68 0 16.558-6.407 22.856-8.789a35.749 35.749 0 0 0 18.014-31.047V44.479A10.216 10.216 0 0 0 163 35.092l-32.656-7.458v-.01Z"
        clipRule="evenodd"
      />
      <path
        fill="#71C9C4"
        d="M121.591 80.128a2 2 0 0 0-2-2h-9.54a2 2 0 0 1-2-2v-8.752a2 2 0 0 1 2-2h9.54a2 2 0 0 0 2-2V52.742a2 2 0 0 1 2-2h9.116a2 2 0 0 1 2 2v10.634a2 2 0 0 0 2 2h9.904a2 2 0 0 1 2 2v8.752a2 2 0 0 1-2 2h-9.904a2 2 0 0 0-2 2v10.634a2 2 0 0 1-2 2h-9.116a2 2 0 0 1-2-2V80.128Z"
      />
    </g>
    <defs>
      <filter
        id="a"
        width="280"
        height="168.41"
        x="-11.668"
        y="-4.205"
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feMorphology
          in="SourceAlpha"
          radius="4"
          result="effect1_dropShadow_2185_1401"
        />
        <feOffset dy="8" />
        <feGaussianBlur stdDeviation="8" />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_2185_1401"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_dropShadow_2185_1401"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);

export type TProps = {
  width?: number;
  height?: number;
  className?: string;
};
